// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"b14c7350","672":"2ad8c523"}[chunkId] + ".chunk.js";
};